// extracted by mini-css-extract-plugin
export default {"ul":"VerticalList_ul__WOXWD","li":"VerticalList_li__6Iiby"};